import { render, staticRenderFns } from "./mainbusinessPage10.vue?vue&type=template&id=d72bf316&scoped=true&"
import script from "./mainbusinessPage10.vue?vue&type=script&lang=js&"
export * from "./mainbusinessPage10.vue?vue&type=script&lang=js&"
import style0 from "./mainbusinessPage10.vue?vue&type=style&index=0&id=d72bf316&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72bf316",
  null
  
)

export default component.exports